/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * * `CHECKBOX` - Checkbox * `DATE` - Date * `FLOAT` - Float * `INTEGER` - Integer * `SELECT` - Select * `TEXT` - Text * `CONTACT` - Contact * `PIC` - Property Identification Code * `PRICE_GRID` - Price Grid * `STAFF` - Staff * `MEDIA` - Media * `CALCULATED` - Calculated * `PIC_ATTRIBUTE` - PIC Attribute
 * @export
 * @enum {string}
 */
export enum BookingPropertyTypesEnum {
    Checkbox = 'CHECKBOX',
    Date = 'DATE',
    Float = 'FLOAT',
    Integer = 'INTEGER',
    Select = 'SELECT',
    Text = 'TEXT',
    Contact = 'CONTACT',
    Pic = 'PIC',
    PriceGrid = 'PRICE_GRID',
    Staff = 'STAFF',
    Media = 'MEDIA',
    Calculated = 'CALCULATED',
    PicAttribute = 'PIC_ATTRIBUTE'
}



